const themes =  [
    {
        colorName: 'Tapestry',
        name: 'cust-theme-1',
        colorHex: '#b56a9f',
        colorAccent: '#21e2f3'
    },
    {
        colorName: 'Atlantis',
        name: 'cust-theme-2',
        colorHex: '#9fcb3d',
        colorAccent: '#da9400'
    },
    {
        colorName: 'Indigo',
        name: 'cust-theme-3',
        colorHex: '#4679cc',
        colorAccent: '#da9400'
    },
    {
        colorName: 'Dodger Blue',
        name: 'cust-theme-4',
        colorHex: '#2198F3',
        colorAccent: '#39a3f4'
    },
    {
        colorName: 'Tradewind',
        name: 'cust-theme-5',
        colorHex: '#6ab5b4',
        colorAccent: '#7bbdbd'
    },
    {
        colorName: 'Cranberry',
        name: 'cust-theme-6',
        colorHex: '#dd5293',
        colorAccent: '#da9400'
    },
    {
        colorName: 'Oslo Gray',
        name: 'cust-theme-7',
        colorHex: '#868e96',
        colorAccent: '#ffca5b'
    },
    {
        colorName: 'Chetwode Blue',
        name: 'cust-theme-8',
        colorHex: '#7c91df',
        colorAccent: '#fff5ed'
    },
    {
        colorName: 'Apricot',
        name: 'cust-theme-9',
        colorHex: '#e59c6c',
        colorAccent: '#d5c519'
    },
    {
        colorName: 'Blue Smoke',
        name: 'cust-theme-10',
        colorHex: '#778c85',
        colorAccent: '#bbc121'
    },
    {
        colorName: 'Green Smoke',
        name: 'cust-theme-11',
        colorHex: '#a2b077',
        colorAccent: '#e892d7'
    },
    {
        colorName: 'Wild Blue Yonder',
        name: 'cust-theme-12',
        colorHex: '#7976b3',
        colorAccent: '#89da00'
    },
    {
        colorName: 'Emerald',
        name: 'cust-theme-13',
        colorHex: '#55ce5f',
        colorAccent: '#89da00'
    },
    {
        colorName: 'Supernova',
        name: 'cust-theme-14',
        colorHex: '#fbe231',
        colorAccent: '255, 206, 26'
    },
    {
        colorName: 'Hoki',
        name: 'cust-theme-15',
        colorHex: '#627ca0',
        colorAccent: '#ffce1a'
    },
    {
        colorName: 'Indigo Fuschia',
        name: 'cust-theme-16',
        colorHex: '#4679cc',
        colorAccent: '#fd52a3'
    }
]

export default themes 